import "./App.css";
import Article from "./components/Article/Article.jsx";

function App() {
  return (
    <div>
      <Article />
    </div>
  );
}

export default App;
